module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic03.82b658d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic03.png
// module id = 521
// module chunks = 1